import { Box, Typography } from '@mui/material';
import { DatasetElementType } from '@mui/x-charts/internals';
import { useCountModeLabels } from '../../../blueberry/hooks/useCountModeLabels';

type Props = {
  data: DatasetElementType<string | number>[];
  totalCountKey?: string;
};

export const EstimatedCountDisplay = ({
  data,
  totalCountKey = 'totalCount',
}: Props) => {
  const countModeLabels = useCountModeLabels();

  const totalEstimatedCount = data.reduce((sum, item) => {
    const totalCount = item[totalCountKey] as number | undefined;
    return sum + (totalCount || 0);
  }, 0);

  return (
    <Box>
      <Typography color='textSecondary' variant='body1'>
        {countModeLabels.total}
      </Typography>
      <Typography
        variant='h1'
        sx={{
          fontSize: '1.25rem',
          fontWeight: 500,
          lineHeight: '175%',
        }}
      >
        {Math.round(totalEstimatedCount).toLocaleString()}
      </Typography>
    </Box>
  );
};
